import { Component } from '@angular/core';

@Component({
    /* Component for displaying feedback text/button and feedback modal. */
    selector: 'my-feedback-component',
    styleUrls: ['feedback.component.scss'],
    templateUrl: 'feedback.component.html'
})
export class FeedbackComponent {
}
